export enum MolSocialMediaTagTypeEnum {
  FACEBOOK = "facebook",
  INSTAGRAM = "instagram",
  WHATSAPP = "whatsapp",
  GOOGLE_SEARCH = "google-search",
  DELIVERECT = "deliverect",
  STRIPE = "stripe",
}
